import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../../constants/actionTypes";
import { JobService } from "../../../Network/services/JobService";
import  ShareJob  from "../../ShareJob";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import StorageHelper from "../../../utils/storageHelper";
import "react-toastify/dist/ReactToastify.css";
import FilePreview from "../../FilePreview";

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const DetailView = (props) => {
  let location = useLocation();
  let history = useHistory();
  const [job, setJob] = useState(location.state?.job || null);
  const [loading, setLoading] = useState(false);
  const [isOwnJob, setIsOwnJob] = useState(false);
  
  
  useEffect(() => {
    if (location.state?.job) {
      const jobData = location.state.job;
      setIsOwnJob(jobData.is_own_job == "1");
      
      if (jobData.is_awarded === "Yes") {
        history.push(`/awardedjob/${jobData.id}`, { item: jobData });
        return;
      }
      
      setJob(jobData);
    } else {
      const jobId = location.pathname.split('/job/')[1]?.split('/')[0];
      if (jobId) {
        setLoading(true);
        
        JobService.getJobById(jobId)
          .then(async (res) => {
            if (res.status == 200 && res.data && res.data.length > 0) {
              const jobData = res.data[0];
              const userData = JSON.parse(localStorage.getItem("UserData"))
              setIsOwnJob(jobData.user_id == userData.id);
              if (jobData.is_awarded === "Yes" ) {
                history.push(`/awardedjob/${jobData.id}`, { item: jobData });
                return;
              }
              
              setJob(jobData);
            } else {
              toast.error("Job not found, Please try Login again", {
                position: "top-right",
                type: "error",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
              });
            }
          })
          .catch((err) => {
            toast.error("Something went wrong! please try again later!!", {
              position: "top-right",
              type: "error",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, [location, history]);
  
  const [selected, setSelected] = useState("By Terms");
  const [description, setDescrption] = useState("");
  const [amount, setAmount] = useState("");
  const [scopefile, setScopefile] = useState({ });
  const [scopeValidation, setScopeValidation] = useState("");
  const [BidAmount, setBidAmount] = useState("");
  const [scope, setScope] = useState("");
  const [openShareJob, setOpenSharejob] = useState(false);

  const [milestoneView, setMilestoneView] = useState([]);
  const [milestoneDes, setMilestoneDes] = useState([]);
  const [milestoneAmount, setMilestoneAmount] = useState([]);
  const [additionalCondition, setAdditionalCondition] = useState("");
  useEffect(() => {
    if (job?.job_plan?.is_premium === "0") {
      setSelected("By Completion"); 
    }
  }, [job]);
  useEffect(() => {});
  let back = (e) => {
    e.preventDefault();
    window.location.href = "/";
  };
  function onFilesChange(event) {
    let file = event.target.files[0];

    if (file.size > 10e6) {
      toast.success("File size must be less than 2MB", {
              position: "top-right",
              type: "error",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
      return;
    }
    setScopefile(event.target.files[0]);
  }

  const onFilesError = (error, file) => {
    setScopeValidation(error.message);
  };

  const toggleModel = () =>{
    setOpenSharejob(prevCheck => !prevCheck);
  }

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }





  function humanFileSize(size) {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) * 1 +
      " " +
      ["B", "kB", "MB", "GB", "TB"][i]
    );
  }
  const onCompletion = (e) => {
    e.preventDefault();
    setSelected("By Completion");
  };
  const onbyTerms = (e) => {
    e.preventDefault();
    setSelected("By Terms");
  };
  const onMilestone = (e) => {
    e.preventDefault();
    setSelected("By Milestone");
  };

  const submitquote = () => {

    
    if (selected === "By Milestone") {
      const staticAmount = parseFloat(amount) || 0;
      const dynamicAmount = milestoneAmount.reduce((sum, amt) => {
        return sum + (parseFloat(amt) || 0);
      }, 0);
      const totalMilestoneAmount = staticAmount + dynamicAmount;
      
      
      if (totalMilestoneAmount !== parseFloat(BidAmount)) {
        toast.error(`Total milestone amount (${totalMilestoneAmount}) must equal bid amount (${BidAmount})`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }
      
      const staticDescriptionEmpty = !description.trim();
      const dynamicDescriptionsEmpty = milestoneDes.filter(desc => !desc.trim());
      
      if (staticDescriptionEmpty || dynamicDescriptionsEmpty.length > 0) {
        toast.error("Please provide descriptions for all milestones", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }
    }
    
    setLoading(true);
    const form = new FormData();
    form.append("quote_id", job.id);
    form.append("job_bid_type", selected);
    form.append("bid_payment_terms", "");
    form.append(
      "milestone_descriction[]",
      selected == "By Milestone"
        ? description == ""
          ? milestoneDes.join(",")
          : description + "," + milestoneDes.join(",")
        : ""
    );
    form.append("work_scope", scope);
    form.append("amount", BidAmount);
    form.append(
      "milestone_amount[]",
      selected == "By Milestone"
        ? amount == ""
          ? milestoneAmount.join(",")
          : amount + "," + milestoneAmount.join(",")
        : ""
    );
    form.append("additional_comment", additionalCondition);

    if (scopefile.name != null) {
      form.append("attach_portfolio", scopefile);
    }

    JobService.submitquote(form, false)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          setTimeout(() => {window.location.href = '/myjobs'},1000)
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // Show loading state while fetching job data
  if (loading) {
    return (
      <section className="explore explore1">
        <div className="container">
          <div className="text-center quote-detail-center-padding">
            <div className="spinner-border" role="status">
            </div>
            <p>Loading job details...</p>
          </div>
        </div>
      </section>
    );
  }

  if (!job) {
    return (
      <section className="explore explore1">
        <div className="container">
          <div className="text-center quote-detail-center-padding">
            <h3>Job not found</h3>
            <p>The job you're looking for could not be found or the link is invalid. Please try Login again</p>
            <button className="btn" onClick={() => history.push('/')}>
              Go to Home
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-6">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <div onClick={back}>
                      <a href="#">
                        <i className="bx bx-chevron-left" /> Back to all jobs
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 share-job-button">
              <a href="#" className="btn share-job-button-text" onClick={(e)=>{
                    e.preventDefault();

                    toggleModel();

              }}>
                Share this Job
              </a>
            </div>
          </div>
        </div>
        <div className="explore-details">
          <div className="row">
            <div className="col-md-7">
              <p className="jobid">
                Job#{" "}
                <span>
                  {job?.job_unique_id?.substr(
                    job?.job_unique_id?.indexOf(" ") + 1
                  )}
                </span>
              </p>
              {/* <ul className="list-one">
                <li>
                  <a href="#!">
                    {job?.payment_term} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!" />
                  {job?.timestamp} <span>|</span>
                </li>
                <li>
                  <a href="#!">
                  Targeted close date {job?.target_closed_date}{" "}
                    <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {job?.total_quotes_received} Quotes Received
                  </a>
                </li>
              </ul> */}
              <h1 className="title">{job?.job_title}</h1>
              <ul className="list-two">
                <li>
                  <a href="#!">
                    {job?.job_location} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {job?.payment_term} <span>|</span>
                  </a>
                </li>
                {/* <li>
                  <a href="#!">
                    {job?.budjet}{" "}
                    <img src="/assets/images/rupee.png" />{" "}
                    <span className="amount">{job?.amount}</span>
                  </a>
                </li> */}
                <li>
                  <a href="#!" >
                  {job?.timestamp} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                  Targeted close date {job?.target_closed_date}{" "}
                    <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {job?.total_quotes_received} Quotes Received
                  </a>
                </li>
              </ul>
              <p className="job-details-label quote-detail-job-label-no-margin">Project Budget </p>
              <div className="payment-amount">
                ₹{job.amount}
              </div>
              <p className="job-details-label">Category</p>
              <div className="job-category">
                {job.parent_category_name && job.category_full_name
                  ? `${job.parent_category_name} > ${job.category_full_name}`
                  : job.category_full_name || job.category || 'General'}
              </div>
              {job.skills && (
                <>
                  <p className="job-details-label">Required Skills</p>
              <ul className="category-list">
                          {job.skills.split(',').map((skill, index) => (
                            <li key={index} className="skill-tag">
                              {skill.trim()}
                            </li>
                          ))}
              </ul>
                </>
              )}
              <p className="job-details-label quote-detail-job-label-no-margin">About Job</p>
              <p>{job?.job_description}</p>
              
              {job?.attach_file && job.attach_file.length > 0 && (
                <>
                  <p className="job-details-label">Attachments</p>
                  <div className="form-group myresume-file-preview-container">
                    {job.attach_file.split(",").map((file, index) => (
                      <FilePreview 
                        key={index}
                        fileUrl={file}
                      />
                    ))}
                    </div>
                </>
              )}
                  
            </div>

            <div className="col-md-5">
              <div className="sidebar">
                <LoadingOverlay>
                    <h1 className="title">Submit Quote</h1>
                  <div className="quote-detail-plan-info-box">
                    <h6 className={job?.job_plan?.is_premium === "0" ? "quote-detail-plan-title-lite" : "quote-detail-plan-title"}>
                      {job?.job_plan?.subscription_name} Plan
                    </h6>
                    <p className={`quote-detail-plan-description ${job?.job_plan?.is_premium === "0" ? "quote-detail-plan-description-lite" : ""}`}>
                      {job?.job_plan?.is_premium === "0" 
                        ? "Escrow fund not available for fund protection and Payment terms must be directly discussed and agreed"
                        : "Get Escrow protection, priority support, and extra benefits for a secure, hassle-free experience."
                      }
                    </p>
                  </div>
                  <h6>Amount you would like to quote for this job?</h6>
                  <div className="col-md-12 quote-detail-no-padding-right">
                    <input
                      type="text"
                      name
                      value={BidAmount}
                      className="quote-detail-bid-input"
                      onChange={(e) => {
                        const value = e.target.value;
                        
                        const numericRegex = /^[0-9]*\.?[0-9]*$/;
                        
                        if (value === '' || numericRegex.test(value)) {
                          const numericValue = parseFloat(value);
                          
                          if (value !== '' && (numericValue >= 1000000 || numericValue < 1)) {
                            toast.error("Bid amount should be between 1 and 9,99,999 INR", {
                              toastId: "bid-amount-exceed-limit",
                              position: "top-right",
                              autoClose: 3000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                            });
                            return; 
                          }
                          
                          setBidAmount(value);
                        } else {
                          toast.error("Please enter only numeric values", {
                            toastId: "numeric-validation-error",
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                          });
                        }
                      }}
                      placeholder="Biding Amount"
                    />
                  </div>

                  <h6>
                    Choose a Payment term{" "}
                    <img src="/assets/images/exclamation.png" className="quote-detail-exclamation-icon" />
                  </h6>
                  <ul className="payment">
                    <li>
                      <Link
                        to="#"
                        className={`${selected === "By Terms" ? "quote-detail-payment-border-selected" : "quote-detail-payment-border-default"} ${job?.job_plan?.is_premium === "0" ? "quote-detail-payment-disabled" : "quote-detail-payment-enabled"}`}
                        onClick={job?.job_plan?.is_premium === "0" ? (e) => e.preventDefault() : onbyTerms}
                      >
                        <img src="/assets/images/terms.png" />
                        <span>By GigFWS Term</span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className={`${selected === "By Milestone" ? "quote-detail-payment-border-selected" : "quote-detail-payment-border-default"} ${job?.job_plan?.is_premium === "0" ? "quote-detail-payment-disabled" : "quote-detail-payment-enabled"}`}
                        onClick={job?.job_plan?.is_premium === "0" ? (e) => e.preventDefault() : onMilestone}
                      >
                        <img src="/assets/images/milestone.png" />
                        <span>By Milestone</span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className={selected === "By Completion" ? "quote-detail-payment-border-selected" : "quote-detail-payment-border-default"}
                        onClick={onCompletion}
                      >
                        <img src="/assets/images/completion.png" />
                        <span>By Completion</span>
                      </Link>
                    </li>
                  </ul>
                  {selected === "By Milestone" ? (
                    <div>
                      <p>
                        You can divide the project into different small
                        milestones and paid up after completing each one of
                        them.
                      </p>
                      <div className="milestones">
                        <form>
                          <div className="row">
                            <div
                              className="col-md-5 quote-detail-no-padding-right"
                            >
                              <input
                                type="text"
                                name
                                value={description}
                                className="quote-detail-milestone-input-bg"
                                onChange={(e) => {
                                  const value = e.target.value.replace(/,/g, '');
                                  setDescrption(value);
                                }}
                                placeholder="Details about Milestone"
                              />
                            </div>
                            <div
                              className="col-md-2 quote-detail-no-padding-right"
                            >
                              <input
                                type="text"
                                name
                                value={amount}
                                className="quote-detail-milestone-input-bg"
                                onChange={(text) => {
                                  const value = text.target.value;
                                  const numericRegex = /^[0-9]*\.?[0-9]*$/;

                                  if (value === '' || numericRegex.test(value)) {
                                    const numericValue = parseFloat(value);

                                    if (value === '' || /^\d+$/.test(value)) {
                                      if (value !== '' && (numericValue >= 1000000 || numericValue < 1)) {
                                        toast.error("Milestone amount should be between 1 and 9,99,999 INR", {
                                          toastId: "milestone-amount-exceed-limit",
                                          position: "top-right",
                                          autoClose: 3000,
                                          hideProgressBar: false,
                                          closeOnClick: true,
                                          pauseOnHover: true,
                                          draggable: true,
                                          progress: undefined,
                                        });
                                        return;
                                      }
                                      setAmount(value);
                                    } else {
                                      toast.error("Please enter only numbers", {
                                        position: "top-right",
                                        autoClose: 2000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                      });
                                    }
                                  }
                                }}
                                placeholder="Amount"
                              />
                            </div>
                            <div
                              className="col-md-5 quote-detail-no-padding-right"
                            >
                                <button
                                  className="btn send quote-detail-milestone-button"
                                  disabled={(amount ? 1 : 0) + milestoneAmount.length >= 20}
                                  onClick={(e) => {
                                  e.preventDefault();
                                  
                                  const totalMilestones = (amount ? 1 : 0) + milestoneAmount.length;
                                  
                                  if (totalMilestones >= 20) {
                                    toast.error("Maximum 20 milestones allowed", {
                                      position: "top-right",
                                      autoClose: 3000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: true,
                                    });
                                    return;
                                  }
                                  
                                  if (!BidAmount || !/^\d+$/.test(BidAmount)) {
                                    toast.error("Please enter a valid bid amount first", {
                                      position: "top-right",
                                      autoClose: 3000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: true,
                                    });
                                    return;
                                  }
                                  
                                  const staticAmount = parseFloat(amount) || 0;
                                  const dynamicAmount = milestoneAmount.reduce((sum, amt) => {
                                    return sum + (parseFloat(amt) || 0);
                                  }, 0);
                                  const totalMilestoneAmount = staticAmount + dynamicAmount;
                                  
                                  const remainingAmount = parseFloat(BidAmount) - totalMilestoneAmount;
                                  
                                  if (remainingAmount <= 0) {
                                    toast.error("Total milestone amount already equals or exceeds bid amount", {
                                      position: "top-right",
                                      autoClose: 3000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: true,
                                    });
                                    return;
                                  }
                                  
                                  setMilestoneView([...milestoneView, milestoneView.length]);
                                  setMilestoneAmount([...milestoneAmount, remainingAmount.toString()]);
                                  setMilestoneDes([...milestoneDes, ""]);
                                  
                                }}
                              >
                                Add Milestone
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      {milestoneView.map((value, index) => (
                        <div className="milestones">
                          <form>
                            <div className="row">
                            <div
                              className="col-md-5 quote-detail-no-padding-right"
                            >
                                <input
                                  type="text"
                                  name
                                  value={
                                    milestoneDes.length > index
                                      ? milestoneDes[index]
                                      : ""
                                  }
                                  className="quote-detail-milestone-input-bg"
                                  onChange={(text) => {
                                    const value = text.target.value.replace(/,/g, '');
                                    setMilestoneDes([
                                      ...milestoneDes.slice(0, index),
                                      value,
                                      ...milestoneDes.slice(index + 1),
                                    ]);
                                  }}
                                  placeholder="Details about Milestone"
                                />
                              </div>
                              <div
                                className="col-md-2 quote-detail-no-padding-right"
                              >
                                <input
                                  type="text"
                                  name
                                  value={
                                    milestoneAmount.length > index
                                      ? milestoneAmount[index]
                                      : ""
                                  }
                                  className="quote-detail-milestone-input-bg"
                                  onChange={(text) => {
                                    const value = text.target.value;
                                    
                                    const numericRegex = /^[0-9]*\.?[0-9]*$/;
                                    
                                    if (value === '' || numericRegex.test(value)) {
                                      const numericValue = parseFloat(value);
                                      
                                      if (value !== '' && (numericValue >=   1000000 || numericValue < 1)) {
                                        toast.error("Milestone amount should be between 1 and 9,99,999 INR", {
                                          toastId: "milestone-amount-exceed-limit",
                                          position: "top-right",
                                          autoClose: 3000,
                                          hideProgressBar: false,
                                          closeOnClick: true,
                                          pauseOnHover: true,
                                          draggable: true,
                                          progress: undefined,
                                        });
                                        return; 
                                      }

                                      if (value !== '' && BidAmount) {
                                        const currentMilestoneAmounts = [...milestoneAmount];
                                        currentMilestoneAmounts[index] = value;
                                        const totalMilestoneAmount = currentMilestoneAmounts.reduce((sum, amt) => {
                                          return sum + (parseFloat(amt) || 0);
                                        }, 0);
                                        
                                        if (totalMilestoneAmount > parseFloat(BidAmount)) {
                                          toast.error(`Total milestone amount (${totalMilestoneAmount}) cannot exceed bid amount (${BidAmount})`, {
                                            toastId: "milestone-total-exceed-bid",
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                          });
                                          return; 
                                        }
                                      }
                                      
                                      setMilestoneAmount([
                                        ...milestoneAmount.slice(0, index),
                                        value,
                                        ...milestoneAmount.slice(index + 1),
                                      ]);
                                    } else {
                                      toast.error("Please enter only numeric values", {
                                        toastId: "milestone-numeric-validation-error",
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                      });
                                    }
                                  }}
                                  placeholder="Amount"
                                  maxLength={6}
                                />
                              </div>
                            <div
                              className="col-md-5 quote-detail-no-padding-right"
                            >
                                  <button
                                    className="btn send quote-detail-milestone-remove-button"
                                    onClick={(e) => {
                                    e.preventDefault();


                                    setMilestoneView(
                                      milestoneView.filter(
                                        (item, indexid) => indexid !== index
                                      )
                                    );
                                    setMilestoneDes(
                                      milestoneDes.filter(
                                        (item, indexid) => indexid !== index
                                      )
                                    );
                                    setMilestoneAmount(
                                      milestoneAmount.filter(
                                        (item, indexid) => indexid !== index
                                      )
                                    );
                                  }}
                                >
                                  Remove Milestone
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      ))}
                    </div>
                  ) : selected === "By Terms" ? (
                    <ul className="payment-list">
                      <li>20 % Payment @ Intial</li>
                      <li>60 % Payment @ After Service Done</li>
                      <li>20 % Payment @ After Reviewing the entire service</li>
                    </ul>
                  ) : null}
                  <form>
                    <label>Scope of Work</label>
                    <textarea
                      type="text"
                      name
                      value={scope}
                      onChange={(e) => {
                        setScope(e.target.value);
                      }}
                      placeholder="You can ask Additional Enquiries here"
                      defaultValue={""}
                    />
                    <p>
                      Material costs, transportation and all other additional
                      resource costs may/ may not be added. Please ask any
                      questions upfront and get it clarified. You can mention
                      any of your queries in the above box.
                    </p>
                    <div className="files">
                    
                        <p className="file">
                        <label htmlFor="file">

                   <input
                     className="FileUpload1"
                     id="FileInput"
                     name="booking_attachment"
                     type="file"
                     onChange={onFilesChange}
                     onError={onFilesError}
                     accept="image/*,.pdf"
                     accepts={["image/png", "image/jpg",".pdf"]}
                     maxFileSize={1800000}
                     minFileSize={0}
                     clickable
               
                   />
                            <img src="/assets/images/attachments.png" />
                            {scopefile.name==null?"Attach your Proposal and Portfolio":scopefile.name}
                          </label>
                        </p>
                      <label className="error">{scopeValidation}</label>
                    </div>
                  </form>
                  <form style={{marginBottom: '20px'}}>
                    <label>Additional Condition</label>
                    <textarea
                      type="text"
                      name
                      value={additionalCondition}
                      onChange={(e) => {
                        setAdditionalCondition(e.target.value);
                      }}
                      placeholder="Add any additional conditions or requirements here"
                      defaultValue={""}
                    />
                  </form>
                    <div className="row">
                      {isOwnJob ? (
                        <div className="col-md-12 text-center" >
                          <p style={{color: '#f58020'}}>You Posted</p>
                        </div>
                      ) : (
                        <>
                         
                          <div className="col-md-12 text-center">
                            <button className="btn send" onClick={submitquote}>
                              Submit Quote
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  <Loader loading={loading} />
                </LoadingOverlay>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ShareJob isOpen={openShareJob} toggle={toggleModel} jobData={job}/>
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailView);
